interface SessionTokenPayload {
  company_id?: unknown;
}

const normalizeCompanyId = (value: unknown): string | undefined => {
  if (typeof value !== 'string') return undefined;
  const normalized = value.trim();
  return normalized || undefined;
};

/** Decode the canonical tenant claim from a JWT without trusting its contents. */
export const decodeSessionTokenCompanyId = (
  token: unknown
): string | undefined => {
  if (typeof token !== 'string' || !token.trim()) return undefined;

  try {
    const encodedPayload = token.split('.')[1];
    if (!encodedPayload) return undefined;

    const base64 = encodedPayload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '='
    );
    const payload = JSON.parse(atob(padded)) as SessionTokenPayload;
    const companyId = normalizeCompanyId(payload.company_id);
    return companyId === payload.company_id ? companyId : undefined;
  } catch {
    return undefined;
  }
};

/**
 * Return the tenant only when both browser identity sources agree. Cookie
 * updates during impersonation are not atomic, so a mismatch must fail closed
 * instead of briefly combining one tenant's state with another tenant's JWT.
 */
export const resolveSessionCompanyId = (
  cookieCompanyId: unknown,
  authToken: unknown
): string | undefined => {
  const companyId = normalizeCompanyId(cookieCompanyId);
  if (!companyId || typeof authToken !== 'string' || !authToken.trim()) {
    return undefined;
  }

  return decodeSessionTokenCompanyId(authToken) === companyId
    ? companyId
    : undefined;
};
